import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import FTab from '../Tabs';
import styles from './index.module.scss';

import { useLang } from '@/i18n';

export default function TabSwriper() {
    const { t } = useLang('dp3.landing.tabSwriper');

    const items = [
        {
            tabValue: '11',
            tabLabel: t('tab_label1'),
            bottomContent: t('tab_content1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749692869098/pc_tab1.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1749692868122/m_tab1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1749692868122/m_tab1.png',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', button_name: t('tab_label1'), list_name: t('title') || 'none' },
        },
        {
            tabValue: '22',
            tabLabel: t('tab_label2'),
            bottomContent: t('tab_content2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300244968/Frame%202094654234.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1764300200594/m.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1764300200594/m.jpg',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', button_name: t('tab_label2'), list_name: t('title') || 'none' },
        },
        {
            tabValue: '33',
            tabLabel: t('tab_label3'),
            bottomContent: t('tab_content3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749692868881/pc_tab3.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1749692869347/m_tab3.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1749692869347/m_tab3.png',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', button_name: t('tab_label3'), list_name: t('title') || 'none' },
        },
    ];

    return (
        <div
            id="TabSwriper"
            className={`page-tabSwriper ${styles.TabSwriper} GtmModuleData-section`}
            data-section-id={'dp3-TabSwriper'}
            data-section-title={t('title')}
        >
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.TabSwriper}`}>
                {/* <EcoTabSwiper items={items} /> */}
                <FTab title={t('title')} items={items} layout={'Image'} />
            </div>
        </div>
    );
}
